import * as React from 'react';
import {LessonObject} from 'api/lesson/types';

export type LessonViewerContextValue = LessonObject;

export const LessonViewerContext
  = React.createContext<Partial<LessonViewerContextValue>>({});

export default LessonViewerContext;
